
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Breadcrumb from '../../components/feature/Breadcrumb';

export default function About() {
  return (
    <div className="min-h-screen">
      <Header />
      <Breadcrumb />
      <main className="pt-8">
        {/* Hero Section */}
        <section 
          className="py-16 bg-gray-50 relative bg-cover bg-center"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/65a0a173b067424a7e178f858904054e.jpg')`
          }}
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
            <div className="text-center mb-12">
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
                地域のカーライフを支える、<br />確かな技術と信頼。
              </h1>
              <p className="text-xl text-gray-200 max-w-3xl mx-auto leading-relaxed">
                創業以来、地域の皆様のお車を大切にお預かりし、<br />
                安全で快適なカーライフをサポートしてまいりました。
              </p>
            </div>
          </div>
        </section>

        {/* Company Overview */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl font-bold text-slate-800 mb-6">代表挨拶</h2>
                <div className="space-y-4 text-gray-600 leading-relaxed">
                  <p>
                    この度は、〇〇自動車整備工場のホームページをご覧いただき、誠にありがとうございます。
                    代表の〇〇と申します。
                  </p>
                  <p>
                    当工場は創業以来、「お客様の安全を第一に」をモットーに、
                    地域の皆様のカーライフをサポートしてまいりました。
                    国土交通省認証工場として、確かな技術と豊富な経験を持つ整備士が、
                    お客様の大切なお車を責任を持ってお預かりいたします。
                  </p>
                  <p>
                    車検、修理、鈑金塗装から新車・中古車販売まで、
                    お車に関することなら何でもお任せください。
                    これからも地域密着の整備工場として、皆様に愛され続ける工場を目指してまいります。
                  </p>
                </div>
              </div>
              <div className="relative">
                <img 
                  src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80"
                  alt="代表と整備士チーム"
                  className="w-full h-96 object-cover object-top rounded-lg shadow-lg"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Company History */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-slate-800 text-center mb-12">沿革</h2>
            <div className="max-w-4xl mx-auto">
              <div className="space-y-8">
                {[
                  { year: '1985年', event: '〇〇自動車整備工場 創業' },
                  { year: '1990年', event: '国土交通省認証工場 認定取得' },
                  { year: '1995年', event: '鈑金塗装部門 開設' },
                  { year: '2000年', event: '中古車販売部門 開設' },
                  { year: '2010年', event: '工場設備 全面リニューアル' },
                  { year: '2020年', event: '新車販売部門 開設' },
                  { year: '2025年', event: '創業40周年を迎える' }
                ].map((item, index) => (
                  <div key={index} className="flex items-center">
                    <div className="flex-shrink-0 w-24 text-right">
                      <span className="text-lg font-bold text-orange-500">{item.year}</span>
                    </div>
                    <div className="ml-8 flex-1">
                      <div className="bg-white p-4 rounded-lg shadow-sm">
                        <p className="text-gray-800">{item.event}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Certifications */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-slate-800 text-center mb-12">認証・資格</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {[
                {
                  icon: 'ri-award-line',
                  title: '国土交通省認証工場',
                  description: '認証工場番号: 第1234号',
                  detail: '法定点検・車検整備を行う認証を取得'
                },
                {
                  icon: 'ri-user-star-line',
                  title: '自動車整備士',
                  description: '1級・2級整備士 在籍',
                  detail: '国家資格を持つ経験豊富な整備士'
                },
                {
                  icon: 'ri-shield-check-line',
                  title: '損害保険代理店',
                  description: '自動車保険取扱い',
                  detail: 'お客様の万が一に備えた保険サービス'
                }
              ].map((cert, index) => (
                <div key={index} className="text-center p-6 bg-gray-50 rounded-lg">
                  <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${cert.icon} text-3xl text-orange-500`}></i>
                  </div>
                  <h3 className="text-lg font-bold text-slate-800 mb-2">{cert.title}</h3>
                  <p className="text-orange-600 font-medium mb-2">{cert.description}</p>
                  <p className="text-gray-600 text-sm">{cert.detail}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Facility */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-slate-800 text-center mb-12">設備・施設</h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <img 
                  src="https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80"
                  alt="工場外観"
                  className="w-full h-96 object-cover object-top rounded-lg shadow-lg"
                />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-slate-800 mb-6">最新設備で安心整備</h3>
                <div className="space-y-4">
                  {[
                    '最新の車検ライン設備',
                    'コンピューター診断機',
                    '油圧リフト 4基',
                    '塗装ブース完備',
                    '待合室・キッズスペース',
                    '代車完備（軽自動車〜普通車）'
                  ].map((facility, index) => (
                    <div key={index} className="flex items-center">
                      <i className="ri-check-line text-orange-500 text-xl mr-3"></i>
                      <span className="text-gray-700">{facility}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
